import axios from 'axios';
import api from '../ApiAuthService';

export async function index(params : any = []): Promise<any> {
  try {
    let url = '/posts/classifieds?';

    if (params.category_id) {
      url += '&category_id=' + params.category_id;
    }

    if (params.subcategory_id) {
      url += '&subcategory_id=' + params.subcategory_id;
    }

    if (params.search) {
      url += '&search=' + params.search;
    }

    if (params.page) {
      url += '&page=' + params.page;
    }

    if (params.per_page) {
      url += '&per_page=' + params.per_page;
    }

    if (params.country) {
      url += '&country=' + params.country;
    }

    if (params.state) {
      url += '&state=' + params.state;
    }

    if (params.city) {
      url += '&city=' + params.city;
    }

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function get(id: any): Promise<any> {
  try {
    const response = await api.get('/posts/classifieds/' + id);
    return response;
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function getClassifiedTeste(id: any): Promise<any> {
  try {
    const response = await api.get('/posts/classifieds/' + id);
    return response;
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}


